import axios from 'axios'
import auth from './auth'

const baseUrl = process.env.VUE_APP_DATA_URL

const fetchData = (requestPayload, qp) => axios
  .post(baseUrl + `?key=${requestPayload.key}${qp}`, requestPayload, {
    headers: {
      'X-Auth-Token': auth.getAuthToken()
    }
  })
  .then(response => {
    return response.data
  }, error => {
    return { errorCode: error.response }
  })

const exportData = (requestPayload, fileFormat) => axios
  .post(baseUrl + '/export' + `?format=${fileFormat}`, requestPayload, {
    headers: {
      'X-Auth-Token': auth.getAuthToken()
    },
    responseType: 'blob'
  })
  .then(response => {
    return response.data
  }, error => {
    return { errorCode: error.response }
  })

export default {
  fetchData,
  exportData
}
